module.exports = __webpack_public_path__ + "static/media/Bell_beaker_mba_wales_text_03.c4ece20a.jpg";